import apiClient from './apiClient'


const getTemplates = (dealerId) => {
  return apiClient.get(`/Template/${dealerId}`)
}

const updateTemplates = (dealerId, templates) => {
  return apiClient.put(`/Template/${dealerId}`, templates)
}

const getSMSByKeyword = (dealerId, keyword) => {
  return apiClient.get(`/Template/${dealerId}/${keyword}`)
}

const sendSMSByKeyword = (dealerId, keyword, sms) => {
  const data = {
    dealerId,
    sms
  }
  return apiClient.put(`/Template/${dealerId}/${keyword}/SendSMS`, data)
}


export default {
  getTemplates,
  updateTemplates,
  getSMSByKeyword,
  sendSMSByKeyword
}
